import { useTheme } from "@material-ui/core";
import React from "react";
import { PieChart, Pie, ResponsiveContainer, Tooltip } from "recharts";

function TwoLevelPieChart({ data }) {
  const muiTheme = useTheme();

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart width={900} height={900}>
        <Pie
          data={data["in"]}
          dataKey="value"
          cx="50%"
          cy="50%"
          outerRadius={60}
          fill={muiTheme.palette.content.mainColor}
        />
        <Pie
          data={data["out"]}
          dataKey="value"
          cx="50%"
          cy="50%"
          innerRadius={70}
          outerRadius={90}
          fill={muiTheme.palette.content.oppositeMainColor}
          label={(entry) => `${entry.name} (${entry.value})`}
        />
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
}

export default TwoLevelPieChart;
